
            const data = {"name":"valid","data":{"width":"9","height":"7","viewBox":"0 0 9 7","data":"<path pid=\"0\" d=\"M6.885.207a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L.239 3.62a.75.75 0 1 1 1.06-1.06l2.094 2.093L6.866.229a.267.267 0 0 1 .02-.022h-.001Z\" _fill=\"#fff\"/>","originalColors":[{"type":"fill","color":"#fff"}],"stopColors":[]}}
        
                    module.exports = data
                    